<svg
  [attr.width]="size"
  [attr.height]="size"
  viewBox="0 0 28 28"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect x="0.5" y="0.5" width="27" height="27" rx="7.5" fill="#494949"/>
  <rect x="0.5" y="0.5" width="27" height="27" rx="7.5" stroke="#F6F6F6"/>
  <path
    d="M11.9399 19.2797L16.2866 14.9331C16.7999 14.4197 16.7999 13.5797 16.2866 13.0664L11.9399 8.71973"
    fill="#FDFDFD"
  />
</svg>
